import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/animations.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('PWA: Service Worker registered successfully', registration.scope);
      })
      .catch((error) => {
        console.log('PWA: Service Worker registration failed', error);
      });
  });
}
